export const environment = {
  production: true,
  apiUrl: 'https://api.asc.tesseramento.app/api/services/',
  documentUrl: 'https://api.asc.tesseramento.app/api/uploads/',
  client: 'asc',
  logoLogin: 'assets/img/logo-asc.svg',
  logoRight: '../../../assets/img/asc-logo-right.svg',
  logoLeft: '../../../assets/img/asc-logo-left.svg',
  nomeCliente: 'ASC',
  nomeSync: 'CONI',
  logoSync: '/assets/img/svg/coni_logo.svg'
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts